import { UploadProcessDocument } from 'modules/documents/hooks/useGetUploadProcessDocuments'

export const uploadProcessDocumentsToMatches = (
  documentIds: string[],
  items: UploadProcessDocument[]
): Record<string, string[]> => {
  const filteredItems = items.filter(
    (item) => documentIds.includes(item.documentId) && !!item.matchedEmployeeId
  )

  return filteredItems.reduce((acc: { [key: string]: string[] }, item) => {
    if (!acc[item.documentId]) {
      acc[item.documentId] = []
    }

    const indexedItem = acc[item.documentId]

    if (indexedItem && item.matchedEmployeeId) {
      indexedItem.push(item.matchedEmployeeId)
    }

    return acc
  }, {})
}
